import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Select } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import { getColumns, getData, getIsLoading } from '../redux/selectors/RouteManagementSelectors';
import { getLeftCheckedMailProcessingCenters, getUserRole } from '../../../common/user/redux/selectors/UserDataSelectors';
import OperatorImpcSelectionCriteriaContainer
  from '../../../common/selection-criteria/operator-impc/container/OperatorImpcSelectionCriteriaContainer';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import { tableLoadData } from '../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import downloadTypes from '../../../common/tables/excel/DownloadTypes';
import { RouteManagementContainerStyle } from './RouteManagementContainer.styles';

function getTableDownloadTemplate(appContext) {
  switch (appContext) {
    case 'tray':
    case 'bag':
      return 'ROUTE_MANAGEMENT_PAGE_FOR_TRAY_AND_BAG';
    case 'pallet':
    default:
      return 'ROUTE_MANAGEMENT_PAGE_FOR_PALLET_BOX';
  }
}

const options = [
  { label: 'All', value: 'BOTH' },
  { label: 'Inbound', value: 'INBOUND' },
  { label: 'Outbound', value: 'OUTBOUND' },
];

class RouteManagementContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showResult: false,
      direction: 'BOTH',
    };
  }

  componentDidMount() {
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    if (params.get('reload') === 'true') {
      this.onCriteriaApply();
    }
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });
    this.props.tableLoadData(
      { tableId: 'ROUTE_MANAGEMENT_PAGE' },
      this.props.appContext.appContext,
      {
        impcCodes: this.props.checkedMailProcessingCenters,
        directionRoute: this.state.direction,
      },
    );
  };

  onDirectionChange = (selected) => {
    this.props.tableLoadData(
      { tableId: 'ROUTE_MANAGEMENT_PAGE' },
      this.props.appContext.appContext,
      {
        impcCodes: this.props.checkedMailProcessingCenters,
        directionRoute: selected.value,
      },
    );
    this.setState({ direction: selected.value });
  };

  render() {
    const {
      appContext: { appContext },
      data,
      columns,
      isLoading,
    } = this.props;
    const { showResult } = this.state;

    return (
      <div>
        <OperatorImpcSelectionCriteriaContainer
          open={data.length === 0}
          title="ROUTE MANAGEMENT"
          onApply={this.onCriteriaApply}
        />
        <RouteManagementContainerStyle>
          <div className="general-content-container">
            {(showResult || data.length > 0) && (
              <div className="full-width">
                <Select
                  value={options.value}
                  placeholder="All"
                  options={options}
                  onChange={this.onDirectionChange}
                  className="select-box"
                />
                {this.props.userRoles.find((userRole) => userRole.includes('MANAGER')) !== undefined && (
                  <Link to={{ pathname: 'create-route' }}>
                    <Button style={{ marginLeft: '30px' }} className="action-buttons">
                      Create Route
                    </Button>
                  </Link>
                )}
                <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                  <ListTable
                    listId={TableDefinitions.ROUTE_MANAGEMENT_PAGE.id}
                    loading={isLoading}
                    columns={columns}
                    data={data}
                    keyField="id"
                    selectCheckbox
                    pagination
                    downloadFileTemplate={getTableDownloadTemplate(appContext)}
                    downloadType={downloadTypes.EXCEL}
                    downloadFileAs="Routes"
                  />
                </div>
              </div>
            )}
          </div>
        </RouteManagementContainerStyle>
      </div>
    );
  }
}

RouteManagementContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.string),
  userRoles: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    userRoles: getUserRole(state),
    isLoading: getIsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RouteManagementContainer);
